export default __webpack_public_path__ + "static/media/folder.77bd03a1.svg";